import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UploadedFileModel } from "./fileupload.model";
import { UserModel } from "./user.model";

export class IssueModel{
    issueId: string;
    ticketNo: number;
    clientId: string;
    callId: string;
    issueCategoryId: string;
    issueCategoryEtc : string;
    productId : string;
    productEtc : string;
    model : string;
    sn : string;
    issue : string;
    status : string;
    createBy : string;
    createTime : DatePipe;
    closeBy : string;
    closeTime : DatePipe;
    files : string[];

    public static getFormGroup()
    {
        var form = new FormGroup({
            issueId: new FormControl(null),
            ticketNo: new FormControl(null),
            clientId : new FormControl(null),
            callId: new FormControl(null),
            issueCategoryId : new FormControl('', Validators.required),
            issueCategoryEtc : new FormControl(null),
            productId : new FormControl(null),
            productEtc : new FormControl(null),
            model : new FormControl(null),
            sn : new FormControl(null),
            issue : new FormControl('', [Validators.required, Validators.maxLength(1024)]),
            status : new FormControl(null),
            createBy : new FormControl(null),
            createTime : new FormControl(null),
            closeBy : new FormControl(null),
            closeTime : new FormControl(null),
        });

        return form;

    }

    public static initializeFormGroup(form){

        return form.setValue({
         issueId: null,
         ticketNo: 0,
         clientId: null,
         callId:null,
         issueCategoryId:null,
         issueCategoryEtc : null,
         productId :null,
         productEtc : null,
         model :null,
         sn : null,
         issue : null,
         status : null,
         createBy : null,
         createTime : null,
         closeBy : null,
         closeTime : null,
        });

    }

    public static populateForm(form, item : IssueModel) {
        return form.setValue(item);
    }

    public static populateFormFromDetailModel(form, item : IssueDetailModel) {
        return form.setValue(IssueDetailModel.convertToIssueModel(item));
    }

}

export class IssueDetailModel extends IssueModel{
    issueCategoryName : string;
    productName : string;
    createByUser : UserModel;
    closeByUser : UserModel;
    trackCount: number;
    fileString : string;
    callLogClientId : string;
    callLogCallId : string;

    public static convertToIssueModel(item : IssueDetailModel)
    {
        var data = new IssueModel();
        data.issueId= item.issueId;
        data.ticketNo= item.ticketNo;
        data.clientId = item.clientId;
        data.callId = item.callId;
        data.issueCategoryId = item.issueCategoryId;
        data.issueCategoryEtc = item.issueCategoryEtc;
        data.productId = item.productId;
        data.productEtc = item.productEtc;
        data.model = item.model;
        data.sn = item.sn;
        data.issue = item.issue;
        data.status = item.status;
        data.createBy = item.createBy;
        data.createTime = item.createTime;
        data.closeBy = item.closeBy;
        data.closeTime = item.closeTime;
        return data;
    }
}

export class IssueTrackModel{
    trackId: string;
    issueId: string;
    callId: string;
    solution: string;
    note: string;
    createBy: string;
    createTime: DatePipe;
    files : string[];

    public static getFormGroup()
    {
        var form = new FormGroup({
            trackId: new FormControl(null),
            issueId: new FormControl(null),
            callId: new FormControl(null),
            solution : new FormControl(''),
            note : new FormControl(null),
            createBy : new FormControl(null),
            createTime : new FormControl(null)
        });

        return form;

    }

    public static initializeFormGroup(form, issueId){

        return form.setValue({
            trackId: null,
            issueId: issueId,
            callId: null,
            solution: null,
            note: null,
            createBy: null,
            createTime: null
        });

    }

    public static populateForm(form, item : IssueTrackModel) {
        return form.setValue(item);
    }

}

export class IssueTrackDetailModel  extends IssueTrackModel {
    fileString : string;
    createByUser: UserModel;
}


export class IssueFileModel{

    issueId: string;
    fileId: string;
    fileType: number;
    fileExtension: string;
    fileName: string;
    fileDescription: string;
    fileUrl: string;


    public static convertFromUploadedFile(data : UploadedFileModel)
    {
        var item = new IssueFileModel();

        item.fileId = data.fileId;
        item.fileType = data.fileType;
        item.fileName = data.fileName;
        item.fileExtension = data.fileExtension;
        item.fileDescription = data.fileDescription;
        item.fileUrl = data.fileUrl;

        return item;
    }
}

export class FaQFileModel  extends IssueFileModel {
    type : string;

}

export class FindSolutionModel
{
    ttype :string;
    id : string;
    issue : string;
    solution : string;
}
